import { Box, AppBar, Toolbar, Typography, useMediaQuery } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";

const Logo = styled("img")(({ theme, ismobile }) => ({
  height: ismobile ? 40 : 48,
  marginRight: theme.spacing(2),
}));

const Layout = ({ children, isRoute, teamName }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{ backgroundColor: "#FFFFFF", color: "inherit" }}
      >
        <Toolbar>
          <Logo
            src="/new_logo.svg"
            alt="PuzzlePanda Logo"
            ismobile={isMobile ? 1 : 0}
          />

          {/* Right-aligned text box */}
          <Box
            sx={{
              ml: "auto",
              px: 2,
              py: 1,
            }}
          >
            {isRoute ? (
              <Typography
                color="#89CFF0"
                noWrap
                sx={{
                  fontSize: {
                    xs: "1.25rem",
                    sm: "1.3rem", 
                    md: "1.5rem", 
                  },
                  fontWeight: 500,
                }}
              >
                Team Leader: {teamName || "N/A"}
              </Typography>
            ) : null}
          </Box>
        </Toolbar>
      </AppBar>

      {/* spacer for fixed AppBar */}
      <Toolbar />

      <Box component="main" bgcolor={"#F2F5F9"} sx={{ flexGrow: 1 }}>
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
